// extracted by mini-css-extract-plugin
module.exports = {"whereContainer":"WherePage_whereContainer__12DBj","label-backgroundcolor":"WherePage_label-backgroundcolor__3N4N4","labelBackgroundcolor":"WherePage_label-backgroundcolor__3N4N4"};